import i18n from "@/i18n";
import { VacancyApplication } from "../../../model/VacancyApplicant.interface";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import ModalManager from "@/components/ModalComponent/ModalManager";
import BFValueDisplay from "@/modules/abstract-ui/data/value-display/BFValueDisplay";
import moment from "moment";
import classNames from "classnames";

type Props = {
  application: VacancyApplication;
};

const VacancyApplicantAdditionalPersonPart = (props: Props) => {
  const { application } = props;

  const { personsHousehold } = application.data;

  const hasAdditionalPersons = personsHousehold && personsHousehold.length > 0;

  const showAdditionalPersons = () => {
    const title = i18n.t(
      "apTemplate:Vacancy.Applicant.AdditionalPerson.Modal.Title",
      "Weitere Personen im Haushalt"
    );
    ModalManager.show({
      title,
      headerCloseButton: true,
      content: <AdditionalPersons application={application} />,
      buttons: [
        {
          text: i18n.t("Globals.Buttons.Close", "Schließen"),
          closeOnClick: true,
          appearance: "primary",
        },
      ],
      size: "fluid",
    });
  };

  return (
    <div>
      <div className="__h3 padding-top-20">
        {i18n.t(
          "apTemplate:Vacancy.Applicant.Label.AdditionalPerson",
          "Weitere Personen im Haushalt"
        )}
        <div>
          {hasAdditionalPersons ? (
            <BFButton
              appearance="link"
              onClick={() => {
                showAdditionalPersons();
              }}
            >
              {i18n.t(
                "apTemplate:Vacancy.Applicant.AdditionalPerson.Show",
                "Anzeigen"
              )}
            </BFButton>
          ) : (
            <div className="__sub-text ">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.AdditionalPerson.None",
                "Keine weiteren Personen im Haushalt"
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VacancyApplicantAdditionalPersonPart;

type AdditionalPersonsProps = {
  application: VacancyApplication;
};

const AdditionalPersons = (props: AdditionalPersonsProps) => {
  const { application } = props;
  const { personsHousehold } = application.data;

  return (
    <div>
      {personsHousehold.map((p, i) => {
        return (
          <div
            key={`${p.dateOfBirth}_${p.firstName}`}
            className={classNames({ "padding-top-10": i > 0 })}
          >
            <div className="__h3">
              {i18n.t(
                "apTemplate:Vacancy.Applicant.Label.PersonalData",
                "Persönliche Daten"
              )}
            </div>
            <div className="__grid __grid-cols-3 __grid-gap-10 __justify-items-start __align-items-center">
              <BFValueDisplay
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.FirstName",
                  "Vorname"
                )}
                value={p.firstName}
              />
              <BFValueDisplay
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.LastName",
                  "Nachname"
                )}
                value={p.lastName}
              />
              <BFValueDisplay
                label={i18n.t(
                  "apTemplate:Vacancy.Applicant.Label.DateOfBirth",
                  "Geburtsdatum"
                )}
                value={moment(p.dateOfBirth).format("DD.MM.YYYY")}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
